import { Modal, Button, Stack, TextInput, Text } from '@mantine/core';
import { useForm } from '@mantine/form';
import { useCreateCostCenter } from '@api/costCenters';

const LEVEL_LABEL: Record<number, string> = { 1: 'Nivel 1', 2: 'Nivel 2', 3: 'Nivel 3' };

interface Props {
  opened: boolean;
  close: () => void;
  fixedLevel: 1 | 2 | 3;
  fixedParentId?: number;
  parentName?: string;
}

function AddCostCenterModal({ opened, close, fixedLevel, fixedParentId, parentName }: Props) {
  const { mutate: createCostCenter } = useCreateCostCenter();

  const form = useForm({
    initialValues: { name: '' },
    validate: {
      name: (v) => (!v ? 'El nombre es requerido' : null),
    },
  });

  function handleSubmit(values: typeof form.values) {
    createCostCenter({
      data: {
        cost_center: {
          name: values.name,
          level: fixedLevel,
          parent_id: fixedParentId ?? null,
        },
      },
    });
    form.reset();
    close();
  }

  return (
    <Modal.Root size="md" opened={opened} onClose={close} centered>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.Title fz={20} fw={600}>
            Nuevo plan de cuenta — {LEVEL_LABEL[fixedLevel]}
          </Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={form.onSubmit(handleSubmit)}>
            <Stack>
              {parentName && (
                <Text fz="sm" c="dimmed">
                  Hijo de: <strong>{parentName}</strong>
                </Text>
              )}
              <TextInput
                label="Nombre"
                placeholder="Nombre del plan de cuenta"
                required
                {...form.getInputProps('name')}
              />
              <Button type="submit" mt="xs">
                Crear
              </Button>
            </Stack>
          </form>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
}

export default AddCostCenterModal;
